import { Divider as NovaBaseDivider, DividerProps as NovaDividerProps } from '@fme-nova/components'
import { default as MuiBaseDivider, DividerProps as MuiDividerProps } from '@mui/material/Divider'

import { createComponentWrapperWithRef } from '../../theme'

export const Divider = createComponentWrapperWithRef<MuiDividerProps | NovaDividerProps>(
  {
    mui: MuiBaseDivider,
    nova: NovaBaseDivider,
  },
  'Divider',
)
